import render from './render'

export default {
  name: 'ThirdCol',

  render
}
